module.exports = __webpack_public_path__ + "static/img/6.8488b50.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/zh/6.png
// module id = 9IRs
// module chunks = 0